import { useCallback, useState } from 'react'

/**
 * A plan mutation can succeed while the billing publish that follows it does not.
 * Retrying the purchase would double-charge, so every surface that changes a plan
 * withholds its success handler in that case and shows `BillingRefreshNotice`.
 *
 * Without `clear`, a surface that stays mounted after a successful retry keeps
 * showing the notice.
 */
export function useBillingRefreshGate() {
  const [needsBillingRefresh, setNeedsBillingRefresh] = useState(false)

  /** Runs `onCurrent` once billing state reflects the change, or raises the notice. */
  const commit = useCallback((billingRefreshed: boolean, onCurrent?: () => void) => {
    if (billingRefreshed) {
      onCurrent?.()
      return
    }
    setNeedsBillingRefresh(true)
  }, [])

  const clear = useCallback(() => setNeedsBillingRefresh(false), [])

  return { needsBillingRefresh, commit, clear }
}
